module.exports = __webpack_public_path__ + "static/media/mock-intro.ea5fbb9e.jpeg";